import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import styles from "./styles.m.css";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { generateImageSources, checkAppSlug } from "../../utils/utils";
import { getPagePath } from "../../../data/collection";
import Icon from "../icon";

const AudioCollectionItem = ({ collection, cardWithImageZoom = true, className = "" }) => {
  const headline = get(collection, ["name"], "");
  const totalItems = get(collection, ["total-count"], 0);
  const imageCaption = get(collection, ["metadata", "cover-image", "caption"]) || headline;
  const slug = get(collection, ["slug"], "");
  const coverImageS3Key = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImageMetaData = get(collection, ["metadata", "cover-image", "cover-image-metadata"], "");

  const checkSlug = checkAppSlug();
  let SourceLink = "";
  if (checkSlug) {
    SourceLink = getPagePath(collection);
  }

  if (!(headline && slug)) {
    return null;
  }

  if (!(collection && collection.items)) {
    return null;
  }

  return (
    <div className={`${styles["read-more-link"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}>
      <div className="container">
        <h1 className={styles["title"]}>
          <span>Download Vikatan App and </span>
          <span>Enjoy Unlimited Audios</span>
        </h1>
        <div className={styles["base"]}>
          <div className={styles["audio-image"]}>
            <Icon type="video-icon" className={styles["audio-icon"]} />
            <ResponsiveImageWithFallback
              className={styles["image-wrapper"]}
              slug={coverImageS3Key}
              metadata={coverImageMetaData}
              alt={imageCaption}
              imgParams={{ auto: ["format", "compress"] }}
              sources={generateImageSources(
                { aspectRatio: [6, 6], screenWidthCoverage: 0.75 },
                { aspectRatio: [4, 3], screenWidthCoverage: 0.3 }
              )}
            />
          </div>
          {/* <div className={styles["content-wrap"]}>
              {collection.summary && <p className={styles["summary"]}>{collection.summary}</p>}
            </div> */}
          <div>
            <h6 className={styles["audio-title"]}>{headline}</h6>
            <div className={styles["audio-episode"]}>
              <Icon type="icon-episode" />
              <span className={styles["audio-episode-text"]}>{totalItems} Episodes</span>
            </div>
            <div className={styles["audio-desc"]}>
              விகடன் App-ஐ டவுன்லோடு செய்து இப்போதே உங்கள் விருப்பமான ஆடியோ புத்தகங்களை கேட்டு மகிழ்ந்திடுங்கள். அதுவும்
              30 நாள்களுக்கு இலவசமாக!
            </div>
            <Link className={styles["cta"]} href="https://onelink.to/xj6egh" externalLink={SourceLink}>
              Download & Get 30 Days Trial
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

AudioCollectionItem.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  className: PropTypes.string,
  collection: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "cover-image-metadata": PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
      }),
      "cover-image-s3-key": PropTypes.string,
      caption: PropTypes.string
    })
  })
};

export default AudioCollectionItem;
